import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { KM } from "../../data/km";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FORM_RELAY = `https://formsubmit.co/ajax/${KM.email}`;
const field = "w-full bg-transparent border-b border-black/20 py-3 text-base sm:text-sm outline-none focus:border-black transition-colors placeholder:text-black/40";
const empty = { event: "", date: "", venue: "", link: "", name: "", email: "" };
const FIELDS = [
  ["event", "Event name", "text"],
  ["date", "Date", "date"],
  ["venue", "Venue / address", "text"],
  ["link", "Event link (optional)", "url"],
  ["name", "Your name", "text"],
  ["email", "Your email", "email"],
];

export default function EventSubmit({ open, onOpenChange }) {
  const [f, setF] = useState(empty);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const close = (v) => { onOpenChange(v); if (!v) setTimeout(() => setDone(false), 300); };
  const submit = async (e) => {
    e.preventDefault();
    if (!f.event.trim() || !f.date || !f.venue.trim() || !f.name.trim()) return toast.error("Please fill in the event name, date, venue and your name.");
    if (!/^\S+@\S+\.\S+$/.test(f.email)) return toast.error("Please add a valid email.");
    setSending(true);
    const details = `Event: ${f.event}\nDate: ${f.date}\nVenue: ${f.venue}\nLink: ${f.link || "-"}`;
    try {
      const res = await fetch(FORM_RELAY, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          _subject: `Culture Calendar submission: ${f.event}`,
          _template: "table",
          _captcha: "false",
          _replyto: f.email,
          Event: f.event, Date: f.date, Venue: f.venue, Link: f.link || "-",
          "Submitted by": f.name, Email: f.email,
        }),
      });
      if (!res.ok) throw new Error("relay");
      axios.post(`${API}/leads`, { name: f.name, email: f.email, interest: "Event submission", message: details }).catch(() => {});
      setDone(true);
      setF(empty);
    } catch {
      toast.error(`Something went wrong. Please try again or email ${KM.email}.`);
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-[520px] max-h-[92svh] overflow-y-auto rounded-none p-6 sm:p-10 bg-white" data-testid="event-submit-dialog">
        <DialogTitle className="km-serif font-normal text-[30px] sm:text-[34px] leading-tight text-[#141414]">{done ? "Thank you!" : "Submit an event"}</DialogTitle>
        <DialogDescription className="km-serif text-[17px] leading-[1.45] text-[#5E5E5E] -mt-1">
          {done ? "Got it. If it’s a fit for the calendar, I’ll add it and may reach out with questions." : "Hosting something the neighborhood should know about? Send me the details."}
        </DialogDescription>
        {done ? (
          <button onClick={() => close(false)} className="km-btn-dark w-full sm:w-auto mt-2" data-testid="event-submit-close">Close</button>
        ) : (
          <form onSubmit={submit} className="space-y-1" noValidate data-testid="event-submit-form">
            {FIELDS.map(([k, label, type]) => (
              <label key={k} className="block">
                <span className={type === "date" ? "km-eyebrow text-[10px] text-black/50 block pt-3" : "sr-only"}>{label}</span>
                <input type={type} className={field} placeholder={type === "date" ? undefined : label} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`event-submit-${k}`} />
              </label>
            ))}
            <div className="pt-6"><button type="submit" disabled={sending} className="km-btn-dark w-full sm:w-auto disabled:opacity-60" data-testid="event-submit-send">{sending ? "Sending..." : "Send Event"}</button></div>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
